<div class="cm-inspector-content">
    @if ($node(); as curve) {
        <cm-inspector-section>
            <ng-container cm-content>
                <cm-value-slot [node]="curve" [key]="'name'" [label]="'Name'"></cm-value-slot>
                <cm-value-slot [node]="curve" [key]="'resolution'" [label]="'Resolution (cm)'"></cm-value-slot>
                <cm-value-slot [node]="curve" [key]="'closed'" [label]="'Closed'"> </cm-value-slot>
            </ng-container>
        </cm-inspector-section>

        <cm-button class="cm-action-button" (click)="addPoint()" [disabled]="sceneManagerService.$watchingForClickedSceneNodePart()">
            <ng-container cm-text> Add Point </ng-container>
        </cm-button>

        @if ($selectedControlPointsIndices(); as selectedControlPointsIndices) {
            @if (selectedControlPointsIndices.length) {
                @for (selectedPointIndex of selectedControlPointsIndices; track $index) {
                    <cm-inspector-section>
                        <ng-container cm-title>Control point {{ selectedPointIndex + 1 }}</ng-container>
                        <ng-container cm-content>
                            <cm-value-slot
                                [node]="curve"
                                [key]="'controlPoints'"
                                [subKey]="[selectedPointIndex, 'corner']"
                                [label]="'Corner Point'"
                                (mouseenter)="onMouseEnter(selectedPointIndex)"
                                (mouseleave)="onMouseLeave()"
                            ></cm-value-slot>
                            <cm-value-slot
                                [node]="curve"
                                [overwrittenValue]="curve.parameters.controlPoints[selectedPointIndex].uvSpace"
                                (updatedOverwrittenValue)="controlPointUVSpaceParameterChanged($event, [selectedPointIndex])"
                                [key]="'controlPoints'"
                                [subKey]="[selectedPointIndex, 'uvSpace']"
                                [label]="'UV Space'"
                                [selectionPossibilities]="$controlPointUVSpaceParameterSelectionPossibilities()"
                                (mouseenter)="onMouseEnter(selectedPointIndex)"
                                (mouseleave)="onMouseLeave()"
                            ></cm-value-slot>
                            <div class="cm-uv-coordinate-slots">
                                <cm-value-slot [node]="curve" [key]="'controlPoints'" [subKey]="[selectedPointIndex, 'uv', 0]" [label]="'U'"></cm-value-slot>
                                <cm-value-slot [node]="curve" [key]="'controlPoints'" [subKey]="[selectedPointIndex, 'uv', 1]" [label]="'V'"></cm-value-slot>
                            </div>
                        </ng-container>
                    </cm-inspector-section>
                }
            }
        }

        <ng-template #setForSelectionOrAll let-controlPointsIndices="controlPointsIndices" let-label="label">
            <cm-inspector-section>
                <ng-container cm-title>Set for {{ label }}</ng-container>
                <ng-container cm-content>
                    <cm-value-slot
                        [node]="curve"
                        [overwrittenValue]="curve.parameters.controlPoints[controlPointsIndices[0]].uvSpace"
                        (updatedOverwrittenValue)="controlPointUVSpaceParameterChanged($event, controlPointsIndices)"
                        [key]="'controlPoints'"
                        [subKey]="[0, 'uvSpace']"
                        [label]="'UV Space'"
                        [selectionPossibilities]="$controlPointUVSpaceParameterSelectionPossibilities()"
                    ></cm-value-slot>
                    <div class="cm-uv-coordinate-slots">
                        <cm-value-slot
                            [node]="curve"
                            [key]="'controlPoints'"
                            [subKey]="[0, 'uv', 0]"
                            [label]="'U'"
                            [overwrittenValue]="curve.parameters.controlPoints[controlPointsIndices[0]].uv[0]"
                            (updatedOverwrittenValue)="controlPointUVCoordinateChanged($event, controlPointsIndices, 0)"
                        ></cm-value-slot>
                        <cm-value-slot
                            [node]="curve"
                            [key]="'controlPoints'"
                            [subKey]="[0, 'uv', 1]"
                            [label]="'V'"
                            [overwrittenValue]="curve.parameters.controlPoints[controlPointsIndices[0]].uv[1]"
                            (updatedOverwrittenValue)="controlPointUVCoordinateChanged($event, controlPointsIndices, 1)"
                        ></cm-value-slot>
                    </div>
                    <cm-button
                        class="cm-action-button"
                        (click)="deletePointsForIndices(controlPointsIndices)"
                        [disabled]="sceneManagerService.$watchingForClickedSceneNodePart()"
                    >
                        <ng-container cm-text> Delete </ng-container>
                    </cm-button>
                </ng-container>
            </cm-inspector-section>
        </ng-template>

        @if ($selectedControlPointsIndices().length) {
            <ng-container
                *ngTemplateOutlet="
                    setForSelectionOrAll;
                    context: {
                        controlPointsIndices: $selectedControlPointsIndices(),
                        label: 'selection',
                    }
                "
            ></ng-container>
        } @else if ($allControlPointsIndices().length) {
            <ng-container
                *ngTemplateOutlet="
                    setForSelectionOrAll;
                    context: {
                        controlPointsIndices: $allControlPointsIndices(),
                        label: 'all',
                    }
                "
            ></ng-container>
        }
    }

    <cm-toggle [(toggle)]="$showTools">
        <ng-container cm-text>Tools</ng-container>
    </cm-toggle>
    @if ($showTools()) {
        <cm-button class="cm-action-button" (click)="addHorizontalLoop()">
            <ng-container cm-text> Add horizontal loop </ng-container>
        </cm-button>

        <cm-button class="cm-action-button" (click)="applyVerticalTranslation()">
            <ng-container cm-text> Offset vertically </ng-container>
        </cm-button>
        <cm-input-container>
            <ng-container cm-inline-label>
                <div class="cm-label">
                    <div class="cm-value-title">Offset:</div>
                </div>
            </ng-container>
            <ng-container cm-input>
                <div class="cm-edit-section">
                    <cm-numeric-input class="cm-input-container" [(value)]="$verticalTranslation"></cm-numeric-input>
                </div>
            </ng-container>
        </cm-input-container>

        <cm-inspector-section>
            <ng-container cm-title>Add loop</ng-container>
            <ng-container cm-content>
                <cm-input-container>
                    <ng-container cm-inline-label>
                        <div class="cm-label">
                            <div class="cm-value-title">Type:</div>
                        </div>
                    </ng-container>
                    <ng-container cm-input>
                        <div class="cm-edit-section">
                            <cm-string-input
                                class="cm-input-container"
                                [value]="$loopOptionTypeLabel()"
                                [readonly]="true"
                                [isButton]="true"
                                [matMenuTriggerFor]="loopTypeMenu"
                            ></cm-string-input>
                        </div>
                    </ng-container>
                </cm-input-container>

                <mat-menu #loopTypeMenu>
                    @for (opt of loopTypeOptions; track opt.value) {
                        <cm-list-item [selected]="$loopOptionType() === opt.value" (click)="$loopOptionType.set(opt.value)">
                            <ng-container cm-title>{{ opt.label }}</ng-container>
                        </cm-list-item>
                    }
                </mat-menu>

                @if ($loopOptionType() === "side") {
                    <cm-input-container>
                        <ng-container cm-inline-label>
                            <div class="cm-label">
                                <div class="cm-value-title">Height:</div>
                            </div>
                        </ng-container>
                        <ng-container cm-input>
                            <div class="cm-edit-section">
                                <cm-numeric-input class="cm-input-container" [(value)]="$loopSideHeight"></cm-numeric-input>
                            </div>
                        </ng-container>
                    </cm-input-container>
                } @else {
                    <cm-input-container>
                        <ng-container cm-inline-label>
                            <div class="cm-label">
                                <div class="cm-value-title">Dist. from border:</div>
                            </div>
                        </ng-container>
                        <ng-container cm-input>
                            <div class="cm-edit-section">
                                <cm-numeric-input class="cm-input-container" [(value)]="$loopDistanceFromBorder"></cm-numeric-input>
                            </div>
                        </ng-container>
                    </cm-input-container>
                }

                <cm-input-container>
                    <ng-container cm-inline-label>
                        <div class="cm-label">
                            <div class="cm-value-title">Pts/corner:</div>
                        </div>
                    </ng-container>
                    <ng-container cm-input>
                        <div class="cm-edit-section">
                            <cm-numeric-input class="cm-input-container" [(value)]="$loopControlPointsPerCorner"></cm-numeric-input>
                        </div>
                    </ng-container>
                </cm-input-container>

                <cm-button class="cm-action-button" (click)="addLoopForOption()">
                    <ng-container cm-text>Add loop</ng-container>
                </cm-button>
            </ng-container>
        </cm-inspector-section>
    }
</div>
